import { Component, Input, OnInit } from '@angular/core';
import { truncateText } from "@app/utils";
/**
 * Componente que representa una sección de un itinerario de vuelo.
 */
@Component({
    selector: 'app-am-itinerary-leg',
    templateUrl: './am-itinerary-leg.component.html',
    styleUrls: ['./am-itinerary-leg.component.scss'],
    standalone: false
})
export class AmItineraryLegComponent implements OnInit {
  /**
   * Número de vuelo.
   *
   * @type {string}
   * @default ''
   */
  @Input() numFlight: string = '';

  /**
   * Hora de salida del vuelo.
   *
   * @type {string}
   * @default ''
   */
  @Input() departureTime: string = '';

  /**
   * Código del aeropuerto de salida.
   *
   * @type {string}
   * @default ''
   */
  @Input() dapartureFlight: string = '';

  /**
   * Código del aeropuerto de llegada.
   *
   * @type {string}
   * @default ''
   */
  @Input() arrivalFlight: string = '';

  /**
   * Hora de llegada del vuelo.
   *
   * @type {string}
   * @default ''
   */
  @Input() arrivalTime: string = '';

  /**
   * Duración del vuelo.
   *
   * @type {string}
   * @default ''
   */
  @Input() flightDuration: string = '';

  /**
   * Hora de abordaje.
   *
   * @type {string}
   * @default ''
   */
  @Input() boardingTime: string = '';
  constructor() { }

  ngOnInit(): void {
  }
    /**
   * Método que trunca un texto a un número específico de caracteres.
   *
   * @param {string} elementTXt - Texto a truncar.
   * @return {string} Texto truncado.
   */
   truncateCopy(elementTXt){
      return truncateText(elementTXt,'8')
  }
}
